import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Agenda from './components/Agenda';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Overview from './components/Overview';
import Outline from './components/Outline';
import Contact from './components/Contact';
import Registration from './components/Registration';

function App() {
  return (
    <>
      <Navbar/>
      <ToastContainer/>
      <Hero/>
    </>
  );
}

export default App;
